export const DASHBOARD_PROJECT_VIEW = 'dashboard';
export const FLOWS_PROJECT_VIEW = '__project_dag__';

const PROJECT_VIEW_SESSION_PREFIX = 'dataunfoldProjectView:';
const SUPPORTED_PROJECT_VIEWS = new Set([
  DASHBOARD_PROJECT_VIEW,
  FLOWS_PROJECT_VIEW,
]);

const getSessionStorage = () => {
  if (typeof window === 'undefined') return null;
  try {
    return window.sessionStorage;
  } catch (_error) {
    return null;
  }
};

const getProjectViewKey = (caseId) => (
  caseId === null || caseId === undefined || caseId === ''
    ? null
    : `${PROJECT_VIEW_SESSION_PREFIX}${String(caseId)}`
);

export const normalizeProjectView = (view) => (
  SUPPORTED_PROJECT_VIEWS.has(view) ? view : DASHBOARD_PROJECT_VIEW
);

export const readProjectViewForSession = (caseId, storage = getSessionStorage()) => {
  const key = getProjectViewKey(caseId);
  if (!key || !storage) return DASHBOARD_PROJECT_VIEW;
  try {
    return normalizeProjectView(storage.getItem(key));
  } catch (_error) {
    return DASHBOARD_PROJECT_VIEW;
  }
};

export const saveProjectViewForSession = (
  caseId,
  view,
  storage = getSessionStorage()
) => {
  const normalizedView = normalizeProjectView(view);
  const key = getProjectViewKey(caseId);
  if (!key || !storage) return normalizedView;
  try {
    storage.setItem(key, normalizedView);
  } catch (_error) {
    // Session view memory is best-effort and must never block navigation.
  }
  return normalizedView;
};
